import { render } from "./ThreadListItem.vue?vue&type=template&id=6dc0acc5&scoped=true"
import script from "./ThreadListItem.vue?vue&type=script&lang=js"
export * from "./ThreadListItem.vue?vue&type=script&lang=js"

import "./ThreadListItem.vue?vue&type=style&index=0&id=6dc0acc5&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc0acc5"]])

export default __exports__